import { IResponsiveSizeType, IResponsiveOptions, IResponsiveConfig } from '../../models/responsive';

export class ResponsiveEventHandler {
	// config
	private defaultSizeType: IResponsiveSizeType;
	private sizes: IResponsiveOptions[];
	private wait: number;
	private onSizeChange: (size: IResponsiveSizeType) => void;

	// state
	private previousSize: IResponsiveSizeType | undefined;
	private currentSize: IResponsiveSizeType;
	private endResizeEvent: NodeJS.Timeout | undefined;

	constructor(config: IResponsiveConfig) {
		this.defaultSizeType = config.defaultSizeType; // should be xsmall
		this.currentSize = this.defaultSizeType;
		this.sizes = config.sizes;
		this.wait = config.wait;
		this.onSizeChange = config.onSizeChange;
		this.bindOnResize = this.bindOnResize.bind(this);
		this.sizeCheck = this.sizeCheck.bind(this);
		this.init();
	}

	public init() {
		this.sizeCheck();
		window.onresize = this.bindOnResize;
	}

	private bindOnResize() {
		if (this.endResizeEvent) {
			clearTimeout(this.endResizeEvent);
		}
		this.endResizeEvent = setTimeout(this.sizeCheck, this.wait);
	}

	public getWidth() {
		return window.innerWidth;
	}

	private sizeCheck() {
		this.updateCurrent();
		if (this.currentSize === this.previousSize) {
			return false;
		}
		if (this.onSizeChange) {
			this.onSizeChange(this.currentSize);
		}
	}

	private updateCurrent() {
		const width = this.getWidth();
		this.previousSize = this.currentSize;
		this.sizes.forEach((size) => {
			const key = Object.keys(size)[0];
			const configBreakpointSize = size[key];
			if (configBreakpointSize <= width) {
				this.currentSize = key as IResponsiveSizeType;
			}
		});
	}

	public getBreakPointWidth(breakpointSize: IResponsiveSizeType) {
		let breakpointWidth = 0;
		this.sizes.forEach((size) => {
			const key = Object.keys(size)[0];
			if (breakpointSize === key) {
				breakpointWidth = size[key];
			}
		});
		return breakpointWidth;
	}

	public getNextBreakpointWidth(breakpointSize: IResponsiveSizeType) {
		let nextBreakpointWidth = 9999;
		this.sizes.forEach((size, idx, sizes) => {
			const key = Object.keys(size)[0];
			if (key === breakpointSize) {
				const nextBreakpointIndex = idx + 1;
				if (sizes.length > nextBreakpointIndex) {
					const nextBreakpointSize = sizes[nextBreakpointIndex];
					const nextBreakpointKey = Object.keys(nextBreakpointSize)[0];
					nextBreakpointWidth = nextBreakpointSize[nextBreakpointKey];
				}
			}
		});
		return nextBreakpointWidth;
	}
}